// © Microsoft Corporation. All rights reserved.

// See https://webpack.js.org/guides/public-path/#on-the-fly for the details of __webpack_public_path__

declare var __webpack_public_path__: string;
const prodAssets = "//assets.msn.com";
const cnProdAssets = "//assets.msn.cn";

const ENV = {
    "microsoftnews.msn.com": prodAssets,
    "microsoftnews-int1.msn.com": prodAssets,
    "microsoftnews.msn.cn": cnProdAssets,
    "microsoftnews-int1.msn.cn": cnProdAssets,
    "microsoftnews-dev.msn.com": prodAssets,
    "ntp.msn.com": prodAssets,
    "ntp.msn.cn": cnProdAssets,
    "owa.msn.com": prodAssets,
    "www.msn.com": prodAssets,
    "www.msn.cn": cnProdAssets,
    "int1.msn.com": prodAssets,
    "int1.msn.cn": cnProdAssets,
    "int.msn.com": prodAssets,
    "int.msn.cn": cnProdAssets,
    "pagecomposition.msn.com": prodAssets,
    "pagecomposition-int.msn.com": prodAssets,
    "windows.msn.com": prodAssets,
    "windows.msn.cn": cnProdAssets,
    "windows-int1.msn.com": prodAssets,
    "windows-int1.msn.cn": cnProdAssets,
    "localhost:6000": prodAssets // for pcs local dev box
};

export const initializePublicPath = () => {
    if (ENV[window.location.host]) {
        const search = decodeURIComponent(window.location.search);
        const isOverriden = search.indexOf("item=spalink:") > -1;
        const isRolling = isOverriden && search.indexOf("item=spalink:rolling") > -1;
        const isStaging = !isOverriden && !isRolling && search.indexOf("bundles=staging") > -1;

        if (isOverriden && !isRolling) {
            __webpack_public_path__ = ENV[window.location.host] + __webpack_public_path__;
        } else {
            // default case without spalink override
            // in order to have the lazy chunk pointing to latest with a stable path, the build number will be overridden on runtime
            // PATHNAME: /bundles/v1/mmx/20190221.2/
            // PATHNAME.split("/"): ["", "bundles", "v1", "mmx", "20190221.2", ""]
            const segments = __webpack_public_path__.split("/");
            if (isRolling) {
                segments[4] = "rolling";
            } else if (isStaging) {
                segments[4] = "staging";
            } else {
                segments[4] = "latest";
            }
            __webpack_public_path__ = ENV[window.location.host] + segments.join("/");
        }
    }
};

export const initializeHybridPublicPath = () => {
    const search = decodeURIComponent(window.location.search);
    if (search.indexOf("item=spa_env:localdev") > -1) {
        // Use active prime instance SPA directory for localdev
        __webpack_public_path__ = `//${window.location.host}/spa/`;
        return;
    }

    const host = ENV[window.location.host] || prodAssets;
    const isOverriden = search.indexOf("item=spalink:") > -1;
    if (isOverriden) {
        __webpack_public_path__ = host + __webpack_public_path__;
    } else {
        // default case without spalink override
        // in order to have the lazy chunk pointing to latest with a stable path, the build number will be overridden on runtime
        // PATHNAME: /bundles/v1/mmx/20190221.2/
        // PATHNAME.split("/"): ["", "bundles", "v1", "mmx", "20190221.2", ""]
        const segments = __webpack_public_path__.split("/");
        segments[4] = "latest";
        __webpack_public_path__ = host + segments.join("/");
    }
};
